import Tables from "../modules/Tables";

function TablesPage() {
  return (
    <div>
      <Tables />
    </div>
  );
}

export default TablesPage;
